import AppConfigs from 'general/constants/AppConfigs';
import axiosClient from './axiosClient';

const chargeConnectorApi = {
  // lay thong tin chi tiet voi sac
  getChargeConnectorDetail: (chargeConnectorId) => {
    const url = `/fe/connector/${chargeConnectorId}`;
    return axiosClient.get(url, {
      baseURL: `${AppConfigs.env.baseUrl}api/v1`,
    });
  },
};

export default chargeConnectorApi;
